export const FORCE_PASSWORD_CHANGE_HEADER_NAME = 'www-authenticate';
export const FORCE_PASSWORD_CHANGE_HEADER_VALUE = 'Basic realm="ForcePasswordReset"';
